import {
  ABTEST,
  ACCORDION,
  ACCORDIONITEM,
  ADARTICLEHERO,
  ADVERTISERDISCLOSURE,
  AIRCONTEXT,
  AMORTIZATIONSCHEDULECALCULATOR,
  ANCHORLINK,
  ANCHORLINKTARGET,
  APOLLOINTEGRATIONCANARY,
  APPDOWNLOADBANNER,
  ARTICLEHERO,
  ARTICLEPAGEHEADER,
  ASKTHENERDSBANNER,
  ASKTHENERDSSUBMITQUESTION,
  AURABANNER,
  AUTHLINK,
  AUTHORSBOX,
  AUTOINSURANCEBANNER,
  AUTOINSURANCECALCULATOR,
  AUTOINSURANCECLICKTABLE,
  AUTOINSURANCEDRCCITIESLIST,
  AUTOINSURANCEDRCCITYTABLE,
  AUTOINSURANCEDRCFIELD,
  AUTOINSURANCEDRCMODELLIST,
  AUTOINSURANCEDRCPROVIDER,
  AUTOINSURANCEDRCTABLE,
  AUTOINSURANCEDRCVEHICLECOMPARISONFIELD,
  AUTOINSURANCEDRCVEHICLESECTIONFIELD,
  AUTOINSURANCEDRCVEHICLETABLE,
  AUTOINSURANCEDRCVEHICLEYEARSECTION,
  AUTOINSURANCEENTRYPOINT,
  AUTOINSURANCEENTRYPOINTFORM,
  AUTOINSURANCEQUOTES,
  AUTOLOANCALCULATOR,
  AUTOLOANSENTRYPOINTBANNER,
  AUTOLOANSFILTER,
  BACKTOTOPLINK,
  BAINFLEXIBLEADBUG,
  BAINGENERICCONTAINER,
  BAINLEADFORMENTRYPOINT,
  BAINREFERRALBANNER,
  BAINSTATICTAXENTRYPOINT,
  BAINTAXSTICKYBANNER,
  BAINTAXVALUEPROPS,
  BANNER,
  BREADCRUMBS,
  BUSINESSLOANCALCULATOR,
  BUTTON,
  CALCULATEDFIELDSFORM,
  CALCULATION,
  CALCULATOR,
  CALCULATORCONDITIONAL,
  CALCULATORINPUT,
  CALCULATORRADIO,
  CALCULATORSELECT,
  CARD,
  CARFULLSPECIFICATION,
  CARGALLERY,
  CARKEYFEATURES,
  CDCALCULATOR,
  CENTEREDCONTAINER,
  CITATION,
  CITATIONLIST,
  CODEBLOCK,
  COLUMN,
  COLUMNS,
  COMPOUNDINTERESTCALCULATOR,
  CONTAINER,
  CONTENTENGAGEMENTSECTION,
  CONTENTHEADING,
  CONTENTIMAGE,
  CONTENTPAGEHEADER,
  CONTENTQUOTE,
  CONTENTRIBBON,
  CONTEXTUALFLEXCARD,
  COSTOFLIVINGCALCULATOR,
  CREDIBLEREFIIFRAME,
  CREDITCARDSABOVESECTIONS,
  CREDITCARDSCOMPACTDRIVERPRODUCTCARD,
  CREDITCARDSCOMPARE,
  CREDITCARDSCOMPARESECTION,
  CREDITCARDSCOMPARESECTIONITEM,
  CREDITCARDSHIGHLIGHTEDOFFERSIDEBAR,
  CREDITCARDSMARKETPLACEPRODUCTCARD,
  CREDITCARDSMULTICOMPARE,
  CREDITCARDSMULTICOMPARESECTION,
  CREDITCARDSMULTICOMPARESECTIONITEM,
  CREDITCARDSOFFERLIST,
  CREDITCARDSOFFERRATESANDFEESLINK,
  CREDITCARDSRELATEDPRODUCTSCONTAINER,
  CREDITCARDSROUNDUPCATEGORYSECTION,
  CREDITCARDSROUNDUPRECAPSECTION,
  CREDITCARDSROUNDUPSUMMARYTABLE,
  CREDITCARDSROUNDUPWITHCOMPAREBAR,
  CREDITCARDSSEARCHLIST,
  CREDITCARDSSINGLEDRIVERPRODUCTCARD,
  CREDITCARDSSPOTLIGHT,
  CREDITCARDSUPDATEDDATESECTION,
  CTAWIDGET,
  DIVIDER,
  DOCUMENT,
  DROPCAPS,
  EDITORIALSTANDARDS,
  ESTATEPLANNINGCARD,
  ESTATEPLANNINGTABLE,
  ESTATEPLANNINGWIDGET,
  EXPANSIONAD,
  EXPANSIONCOMPARISONTABLE,
  EXPANSIONPRODUCTCARD,
  EXPANSIONSUMMARYTABLE,
  EXPERIMENT,
  EXPLORELIST,
  FADECONTAINER,
  FAQ,
  FEATUREDLENDERCARD,
  FILTERCHIPS,
  FIRSTPERSONPERSPECTIVE,
  FIRSTPERSONPERSPECTIVEITEM,
  FUNDERALOANOPTIONCTA,
  FUNDERATOOLLIST,
  FUNDERATOOLLISTITEM,
  GATEDCONTENTBANNER,
  GENERICREFINANCECALCULATOR,
  HEADING,
  HIGHLIGHTEDFACTS,
  HIGHLIGHTSLIST,
  HLMENTRY,
  HLMGENERICENTRY,
  HLMREFINANCEENTRY,
  HOMEAFFORDABILITYCALCULATOR,
  HOMEINSURANCEBANNER,
  HOMEINSURANCECALCULATOR,
  HOMEINSURANCECLICKTABLE,
  HOMEINSURANCEENTRYPOINT,
  HOMEINSURANCEENTRYPOINTFORM,
  HOMEWIDGETIZEDTABLE,
  HOUSEAD,
  HUBHEADER,
  ICONCARDLIST,
  IMAGE,
  INFOGRAM,
  INLINECODE,
  INSTAGRAM,
  INSURANCEAIRFIELD,
  INSURANCEAIRLIST,
  INSURANCEAIRTABLE,
  INSURANCEPRODUCTCARD,
  INSURANCESUMMARYTABLE,
  INVESTING401KCALCULATOR,
  LENDINGBESTOFAWARDWINNERCARD,
  LENDINGCUSTOMIZABLEMARKETPLACERATETABLE,
  LENDINGEXCLUSIVEOFFER,
  LENDINGMARKETPLACESUMMARYTABLE,
  LENDINGMULTIOFFERBANNER,
  LENDINGPRODUCTCARD,
  LENDINGQUICKFORM,
  LENDINGSUMMARYPRODUCTCARD,
  LIFEINSURANCEBANNER,
  LIFEINSURANCECARD,
  LIFEINSURANCEQUOTES,
  LINK,
  LIST,
  LISTITEM,
  LOANESTIMATEENTRYPOINT,
  LOCATIONDATAFIELD,
  LOCATIONDATAPROVIDER,
  LOGOSROW,
  MARKETPLACEAPPLYNOW,
  MARKETPLACECOMPARISONLINK,
  MARKETPLACECOMPARISONTABLE,
  MARKETPLACEENTITYDISPLAYNAME,
  MARKETPLACEENTITYLOGOROW,
  MARKETPLACEENTRYPOINT,
  MARKETPLACEFIELD,
  MARKETPLACEPARTNERPLACEMENT,
  MARKETPLACEPRODUCTCARD,
  MARKETPLACERATETABLE,
  MARKETPLACESTARRATING,
  MARKETPLACETHIRDPARTYEMBED,
  MEDICAREAD,
  MEDICAREINSURANCEENTRYPOINTFORM,
  MEDICARETABBEDPRODUCTCARD,
  MEDICARETABLE,
  MEGAPHONEFM,
  MINIPRODUCTCARD,
  MORELIKETHISLIST,
  MORELINK,
  MORTGAGEBESTOFAWARDWINNERCARD,
  MORTGAGECALCULATOR,
  MORTGAGERATESUMMARY,
  NERDAICHAT,
  NERDTIP,
  NERDUPPROMOTIONALBANNER,
  NERDWALLETADVISORSANNOUNCEMENTBANNER,
  NERDWALLETADVISORSBANNER,
  NERDWALLETADVISORSMATCHDYNAMICBANNER,
  NERDWALLETADVISORSMATCHSTATICBANNER,
  NERDWALLETADVISORSSIDESTICKYBANNER,
  NERDWALLETPLUSBANNER,
  NERDWALLETPLUSCTA,
  NERDWALLETPLUSINSURANCEBANNER,
  NERDYTAKEAWAY,
  NOOP,
  ONETRUSTOPENCONSENT,
  OUTOFDATEMESSAGE,
  OUTSIDEEXPERT,
  PERSONALLOANCALCULATOR,
  PERSONALLOANSBESTOFAWARDWINNERCARD,
  PERSONALLOANSTINYWIDGET,
  PERSONALLOANSWIDGETIZEDTABLE,
  PETINSURANCEBANNER,
  PETINSURANCEINFOCARD,
  POSTLIST,
  PREQUALAPPLICATIONHOUSEAD,
  PREQUALBANNER,
  PRODUCTSTARRATING,
  PROMOCARD,
  PROPERTYTAXTABLE,
  QUESTIONLIST,
  REDIRECT,
  REFERRALBANNER,
  REFINANCECALCULATOR,
  RENDERCONTEXTCONDITIONAL,
  RENTERSINSURANCEBANNER,
  RENTERSINSURANCEENTRYPOINT,
  RENTVSBUYCALCULATOR,
  RETIREMENTCALCULATOR,
  REVIEWDETAILSOFFER,
  REVIEWINTROOFFER,
  REVIEWJSONLD,
  ROTHIRACALCULATOR,
  ROUNDUPJSONLD,
  ROUNDUPOFFERSCD,
  ROUNDUPOFFERSHYSA,
  SCREENSIZECONDITIONAL,
  SCROLLDEPTHCONDITIONAL,
  SEARCHPAGEHEADER,
  SEARCHRESULTLISTDATA,
  SHOWMORETOGGLE,
  SIMILARCARS,
  SMBBUSINESSPROREGISTRATION,
  SMBCOMPARELOANSENTRYPOINT,
  SMBCUSTOMADCTA,
  SMBILLUSTRATIONCARDLIST,
  SMBINFOGATHERINGCTA,
  SMBMULTIDRIVERPRODUCTCARD,
  SMBNEWPRODUCTCARDTILE,
  SMBPARTNERPLACEMENT,
  SMBPRODUCTCARDTILE,
  SMBPROSANDCONSTABLE,
  SMBSINGLEDRIVERPRODUCTCARD,
  SMBSUMMARYTABLE,
  SMBWHYTRUSTNERDWALLET,
  SMBWHYTRUSTNERDWALLETBULLET,
  SOCIALMEDIALINKS,
  SOCIALMEDIASHARELINKS,
  SOCIALSECURITYCALCULATOR,
  SPACER,
  SPOTIFY,
  STARRATING,
  STICKYCONTAINER,
  STUDENTLOANORIGINATIONBANNER,
  STUDENTLOANSBESTOFAWARDWINNERCARD,
  SUPERSCRIPT,
  TAB,
  TABLE,
  TABLEOFCONTENTS,
  TABLEOFCONTENTSTARGET,
  TABS,
  TAXCALCULATOR,
  TAXMONETIZINGADBANNER,
  TEMPLATESECTION,
  TIKTOK,
  TITLE,
  TOOLLIST,
  TOOLLISTITEM,
  TRAVELINSURANCEBANNER,
  TRAVELINSURANCEENTRYPOINT,
  TREASURYYIELDVALUE,
  TRUECARAD,
  TURBOTAXPLACEMENT,
  TWITTER,
  TYPE,
  USERENGAGEMENTCTA,
  USERSEGMENTCONDITIONAL,
  VEHICLEOVERVIEWCARD,
  VIDEO,
  WELL,
  WPAUTHORSBOX,
  WPBIOHEADER,
  WPBLOCK,
  WPCALCULATOR,
  WPCONTENTPAGEHEADER,
  WPCONTENTPAGENERDAICHAT,
  WPDYNAMICPLACEMENT,
  WPEDITLINK,
  WPEMBED,
  WPFEATUREDIMAGE,
  WPHOUSEAD,
  WPHUBHEADER,
  WPHUBLINKS,
  WPINLINEBLOCK,
  WPINSPAGEPOSTLIST,
  WPMARKETPLACEENTRYPOINT,
  WPMETHODOLOGY,
  WPPOSTLIST,
  WPREVIEWPOSTLIST,
  WPSOCIALMEDIALINKS,
  WPTABLE,
} from '@nerdwallet/structured-content/types';
import dynamic from 'next/dynamic';

export default {
  [ABTEST]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/ab-test')
    ),
  [ACCORDION]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/chunks/accordion').then(
        (module) => module.Accordion
      )
    ),
  [ACCORDIONITEM]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/chunks/accordion').then(
        (module) => module.AccordionItem
      )
    ),
  [ADVERTISERDISCLOSURE]: () =>
    dynamic(() =>
      import('@nerdwallet/currency/components/AdvertiserDisclosure').then(
        (module) => module.AdvertiserDisclosure
      )
    ),
  [AIRCONTEXT]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/air-context')
    ),
  [AMORTIZATIONSCHEDULECALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculators/amortization'
      )
    ),
  [AUTHORSBOX]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/authors-box')
    ),
  [AUTOINSURANCEBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-banner'
      )
    ),
  [ANCHORLINK]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/chunks/anchor-link').then(
        (module) => module[ANCHORLINK]
      )
    ),
  [ANCHORLINKTARGET]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/chunks/anchor-link').then(
        (module) => module[ANCHORLINKTARGET]
      )
    ),
  [APOLLOINTEGRATIONCANARY]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/apollo-integration-canary'
      )
    ),
  [APPDOWNLOADBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/app-download-banner'
      )
    ),
  [ADARTICLEHERO]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/ad-article-hero')
    ),
  [ARTICLEHERO]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/article-hero')
    ),
  [ASKTHENERDSBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/ask-the-nerds-banner'
      )
    ),
  [ASKTHENERDSSUBMITQUESTION]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/ask-the-nerds-submit-question'
      )
    ),
  [AUTHLINK]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/auth-link')
    ),
  [AUTOINSURANCEDRCCITIESLIST]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-drc-cities-list'
      )
    ),
  [AUTOINSURANCEDRCFIELD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-drc-field'
      )
    ),
  [AUTOINSURANCEDRCPROVIDER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-drc-provider'
      )
    ),
  [AUTOINSURANCEDRCTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-drc-table/AutoInsuranceDRCCityTable'
      )
    ),
  [AUTOINSURANCEDRCCITYTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-drc-table/AutoInsuranceDRCCityTable'
      )
    ),
  [AUTOINSURANCEDRCMODELLIST]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-drc-model-list'
      )
    ),
  [AUTOINSURANCEDRCVEHICLETABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-drc-table/AutoInsuranceDRCVehicleTable'
      )
    ),
  [AUTOINSURANCEDRCVEHICLEYEARSECTION]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-drc-vehicle-year-section'
      )
    ),
  [AUTOINSURANCEDRCVEHICLESECTIONFIELD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-drc-vehicle-year-section/vehicle-year-section-field'
      )
    ),
  [AUTOINSURANCEDRCVEHICLECOMPARISONFIELD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-drc-vehicle-year-section/vehicle-year-comparison-field'
      )
    ),
  [AUTOINSURANCEENTRYPOINT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-entry-point'
      )
    ),
  [AUTOINSURANCEENTRYPOINTFORM]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-entry-point-form'
      )
    ),
  [AUTOINSURANCEQUOTES]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-quotes'
      )
    ),
  [AUTOLOANCALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculators/auto-loan'
      )
    ),
  [AUTOLOANSENTRYPOINTBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-loans-entry-point-banner'
      )
    ),
  [AUTOLOANSFILTER]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/auto-loans-filter')
    ),
  [BANNER]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/banner')
    ),
  [BACKTOTOPLINK]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/back-to-top-link')
    ),
  // Marking this as Next-compatible only if you use Next compatible components as its children
  // if you pass a non-next compatible component then you'll see an error (0 , f.default)(...) is not a function
  [BAINFLEXIBLEADBUG]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/bain-flexible-ad-bug'
      )
    ),
  [BAINGENERICCONTAINER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/bain-generic-container'
      )
    ),
  [BAINLEADFORMENTRYPOINT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/bain-lead-form-entry-point'
      )
    ),
  [BAINREFERRALBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/bain-referral-banner'
      )
    ),
  [BAINSTATICTAXENTRYPOINT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/bain-static-tax-entry-point'
      )
    ),
  // Could not find "store" in either the context or props of "Connect(ImpressionState)". Either wrap the root component in a <Provider>, or explicitly pass "store" as a prop to "Connect(ImpressionState)".
  // [BAINMARKETPLACECOMPARISONTABLE]: () => [
  //   import('@nerdwallet/structured-content/dist/components/bain-marketplace-comparison-table'),
  // ),
  [BAINTAXVALUEPROPS]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/bain-tax-value-props'
      )
    ),
  [BAINTAXSTICKYBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/bain-tax-sticky-banner'
      )
    ),
  [BREADCRUMBS]: () =>
    dynamic(() =>
      import('@nerdwallet/content-seo-components/components/Breadcrumbs').then(
        (module) => module.Breadcrumbs
      )
    ),
  [BUSINESSLOANCALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/business-loan-calculator'
      )
    ),
  [BUTTON]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/chunks/core').then(
        (module) => module[BUTTON]
      )
    ),
  [CALCULATEDFIELDSFORM]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculated-fields-form'
      )
    ),
  [CALCULATION]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculator/Calculation'
      )
    ),
  [CALCULATOR]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/calculator')
    ),
  [CALCULATORCONDITIONAL]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculator/calculator-conditional'
      )
    ),
  [CALCULATORINPUT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculator/calculator-input'
      )
    ),
  [CALCULATORRADIO]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculator/calculator-radio'
      )
    ),
  [CALCULATORSELECT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculator/calculator-select'
      )
    ),
  [CARFULLSPECIFICATION]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/car-full-specification'
      )
    ),
  [CARGALLERY]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/car-gallery')
    ),
  [CARKEYFEATURES]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/car-key-features')
    ),
  [CDCALCULATOR]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/calculators/cd')
    ),
  [CARD]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/card')
    ),
  [CENTEREDCONTAINER]: () =>
    dynamic(() =>
      import('@nerdwallet/currency/components/CenteredContainer').then(
        (module) => module.CenteredContainer
      )
    ),
  [CITATION]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/chunks/citation').then(
        (module) => module[CITATION]
      )
    ),
  [CITATIONLIST]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/chunks/citation').then(
        (module) => module[CITATIONLIST]
      )
    ),
  [COLUMN]: () =>
    dynamic(() =>
      import('@nerdwallet/currency/components/Column').then(
        (module) => module[COLUMN]
      )
    ),
  [COLUMNS]: () =>
    dynamic(() =>
      import('@nerdwallet/currency/components/Columns').then(
        (module) => module[COLUMNS]
      )
    ),
  [COMPOUNDINTERESTCALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculators/compound-interest'
      )
    ),
  [CONTAINER]: () => dynamic(() => import('@nerdwallet/react-container')),
  [CONTENTHEADING]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/content-heading/content-heading'
      )
    ),
  [CONTENTPAGEHEADER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/content-page-header'
      )
    ),
  [CONTENTIMAGE]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/content-image')
    ),
  [CONTENTQUOTE]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/content-quote')
    ),
  [CONTENTRIBBON]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/content-ribbon')
    ),
  [COSTOFLIVINGCALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculators/cost-of-living'
      )
    ),
  [CREDIBLEREFIIFRAME]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credible-refi-iframe'
      ).then((module) => module[CREDIBLEREFIIFRAME])
    ),
  [CREDITCARDSABOVESECTIONS]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-above-sections'
      )
    ),
  [CREDITCARDSCOMPARE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-compare'
      ).then((module) => module[CREDITCARDSCOMPARE])
    ),
  [CREDITCARDSCOMPARESECTION]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-compare'
      ).then((module) => module[CREDITCARDSCOMPARESECTION])
    ),
  [CREDITCARDSCOMPARESECTIONITEM]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-compare'
      ).then((module) => module[CREDITCARDSCOMPARESECTIONITEM])
    ),
  [CREDITCARDSHIGHLIGHTEDOFFERSIDEBAR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-highlighted-offer-sidebar'
      ).then((module) => module[CREDITCARDSHIGHLIGHTEDOFFERSIDEBAR])
    ),
  [CREDITCARDSMULTICOMPARE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-multi-compare'
      ).then((module) => module[CREDITCARDSMULTICOMPARE])
    ),
  [CREDITCARDSMULTICOMPARESECTION]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-multi-compare'
      ).then((module) => module[CREDITCARDSMULTICOMPARESECTION])
    ),
  [CREDITCARDSMULTICOMPARESECTIONITEM]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-multi-compare'
      ).then((module) => module[CREDITCARDSMULTICOMPARESECTIONITEM])
    ),
  [CREDITCARDSOFFERLIST]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-offer-list'
      )
    ),
  // Could not find "store" in either the context or props of "Connect(ImpressionState)". Either wrap the root component in a <Provider>, or explicitly pass "store" as a prop to "Connect(ImpressionState)".
  // which is bizarre because redux is set up here
  [CREDITCARDSROUNDUPSUMMARYTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-roundup-summary-table'
      )
    ),
  [CREDITCARDSROUNDUPRECAPSECTION]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-roundup-recap-section'
      )
    ),
  [CREDITCARDSROUNDUPCATEGORYSECTION]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-roundup-category-section'
      )
    ),
  [CREDITCARDSROUNDUPWITHCOMPAREBAR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-roundup-category-section-with-compare-bar'
      )
    ),
  [CREDITCARDSSEARCHLIST]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-search-list'
      )
    ),
  [CREDITCARDSSINGLEDRIVERPRODUCTCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-single-driver-product-card'
      )
    ),
  [CREDITCARDSSPOTLIGHT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-spotlight'
      )
    ),
  [CTAWIDGET]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/cta-widget')
    ),
  [DIVIDER]: () =>
    dynamic(() =>
      import('@nerdwallet/currency/components/Divider').then(
        (module) => module.Divider
      )
    ),
  [DOCUMENT]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/chunks/core').then(
        (module) => module.Document
      )
    ),
  [DROPCAPS]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/dropcaps')
    ),
  [EDITORIALSTANDARDS]: () =>
    dynamic(() =>
      import('@nerdwallet/currency/components/EditorialStandards').then(
        (module) => module.EditorialStandards
      )
    ),
  [ESTATEPLANNINGCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/estate-planning-card'
      )
    ),
  [ESTATEPLANNINGTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/estate-planning-table'
      )
    ),
  [ESTATEPLANNINGWIDGET]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/estate-planning-widget'
      )
    ),
  [EXPANSIONAD]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/expansion-ad')
    ),
  [EXPANSIONCOMPARISONTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/expansion-comparison-table'
      )
    ),
  [EXPANSIONPRODUCTCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/expansion-product-card'
      )
    ),
  [EXPANSIONSUMMARYTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/expansion-summary-table'
      )
    ),
  [EXPERIMENT]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/experiment')
    ),
  [EXPLORELIST]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/explore-list')
    ),
  [FADECONTAINER]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/fade-container')
    ),
  [FAQ]: () =>
    dynamic(() => import('@nerdwallet/structured-content/dist/components/faq')),
  [FEATUREDLENDERCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/featured-lender-card'
      )
    ),
  [FILTERCHIPS]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/filter-chips')
    ),
  [FIRSTPERSONPERSPECTIVE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/first-person-perspective'
      )
    ),
  [FIRSTPERSONPERSPECTIVEITEM]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/first-person-perspective/fpp-item'
      )
    ),
  [FUNDERALOANOPTIONCTA]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/fundera-loan-option-cta'
      )
    ),
  [FUNDERATOOLLIST]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/fundera-tool-list'
      ).then((module) => module[FUNDERATOOLLIST])
    ),
  [FUNDERATOOLLISTITEM]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/fundera-tool-list'
      ).then((module) => module[FUNDERATOOLLISTITEM])
    ),
  [GENERICREFINANCECALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculators/refinance'
      ).then((module) => module[GENERICREFINANCECALCULATOR])
    ),
  [HEADING]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/heading/Heading')
    ),
  [HIGHLIGHTEDFACTS]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/highlight-boxes/highlighted-facts'
      )
    ),
  [HIGHLIGHTSLIST]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/highlights-list/highlights-list'
      )
    ),
  [HLMENTRY]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/hlm-entry')
    ),
  [HLMGENERICENTRY]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/hlm-generic-entry')
    ),
  [HLMREFINANCEENTRY]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/hlm-refinance-entry'
      )
    ),
  [HOMEINSURANCEBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/home-insurance-banner'
      )
    ),
  [HOMEINSURANCEENTRYPOINT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/home-insurance-entry-point'
      )
    ),
  [HOMEINSURANCEENTRYPOINTFORM]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/home-insurance-entry-point-form'
      )
    ),
  [HOMEWIDGETIZEDTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/home-widgetized-table'
      )
    ),
  [HOUSEAD]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/chunks/article').then(
        (module) => module[HOUSEAD]
      )
    ),
  [HUBHEADER]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/hub-header')
    ),
  [IMAGE]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/chunks/core').then(
        (module) => module[IMAGE]
      )
    ),
  [INFOGRAM]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/infogram')
    ),
  [INSTAGRAM]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/instagram')
    ),
  [INSURANCEAIRFIELD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/insurance-air-field'
      )
    ),
  [INSURANCEAIRLIST]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/insurance-air-list'
      )
    ),
  [INSURANCEPRODUCTCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/insurance-product-card'
      )
    ),
  [INVESTING401KCALCULATOR]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/calculators/401k')
    ),
  [LENDINGPRODUCTCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/lending-product-card'
      )
    ),
  [LENDINGQUICKFORM]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/lending-quick-form'
      )
    ),
  [LENDINGEXCLUSIVEOFFER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/lending-exclusive-offer'
      )
    ),
  [LENDINGMARKETPLACESUMMARYTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/lending-marketplace-summary-table'
      )
    ),
  [LENDINGMULTIOFFERBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/lending-multi-offer-banner'
      )
    ),
  [LIFEINSURANCEBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/life-insurance-banner'
      )
    ),
  [LIFEINSURANCECARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/life-insurance-card'
      )
    ),
  [LIFEINSURANCEQUOTES]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/life-insurance-quotes'
      )
    ),
  [LINK]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/chunks/core').then(
        (module) => module[LINK]
      )
    ),
  [LIST]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/chunks/core').then(
        (module) => module[LIST]
      )
    ),
  [LISTITEM]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/chunks/core').then(
        (module) => module[LISTITEM]
      )
    ),
  [LOANESTIMATEENTRYPOINT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/loan-estimate-entry-point'
      )
    ),
  [LOCATIONDATAFIELD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-drc-field'
      )
    ),
  [LOCATIONDATAPROVIDER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-drc-provider/location-data-provider'
      )
    ),
  [LOGOSROW]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/logos-row')
    ),
  [MARKETPLACEAPPLYNOW]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/marketplace-apply-now'
      )
    ),
  // DataProvidersContext
  [MARKETPLACECOMPARISONLINK]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/marketplace-comparison-link'
      )
    ),
  [MARKETPLACECOMPARISONTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/marketplace-comparison-table'
      )
    ),
  [MARKETPLACEENTITYDISPLAYNAME]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/marketplace-entity-display-name'
      )
    ),
  [MARKETPLACEENTITYLOGOROW]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/marketplace-entity-logo-row'
      )
    ),
  [MARKETPLACEENTRYPOINT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/marketplace-entry-point'
      )
    ),
  [MARKETPLACEFIELD]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/marketplace-field')
    ),
  // DataProvidersContext
  [MARKETPLACEPARTNERPLACEMENT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/marketplace-partner-placement'
      )
    ),
  [MARKETPLACEPRODUCTCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/marketplace-product-card'
      )
    ),
  [MORELIKETHISLIST]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/more-like-this-list/more-like-this-list'
      )
    ),
  [CREDITCARDSMARKETPLACEPRODUCTCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-marketplace-product-card'
      )
    ),
  [MARKETPLACESTARRATING]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/marketplace-star-rating'
      )
    ),
  [MARKETPLACERATETABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/marketplace-rate-table'
      )
    ),
  [MARKETPLACETHIRDPARTYEMBED]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/marketplace-third-party-embed'
      )
    ),
  [MEDICAREAD]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/medicare-ad')
    ),
  [MEDICAREINSURANCEENTRYPOINTFORM]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/medicare-insurance-entry-point-form'
      )
    ),
  [MEDICARETABBEDPRODUCTCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/medicare-tabbed-product-card'
      )
    ),
  [MEDICARETABLE]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/medicare-table')
    ),
  [MEGAPHONEFM]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/megaphone-fm')
    ),
  // DataProvidersContext
  [MINIPRODUCTCARD]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/mini-product-card')
    ),
  [MORELINK]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/more-link')
    ),
  [MORTGAGEBESTOFAWARDWINNERCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/mortgage-best-of-award-winner-card'
      )
    ),
  [MORTGAGECALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculators/mortgage'
      )
    ),
  [MORTGAGERATESUMMARY]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/mortgage-rate-summary'
      )
    ),
  [NERDAICHAT]: () =>
    dynamic(() =>
      import('@nerdwallet/ai-components/dist/components/nerd-ai-chat').then(
        (module) => module['NerdAIChat']
      )
    ),
  [NERDYTAKEAWAY]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/highlight-boxes/takeaway-box'
      )
    ),
  [NERDTIP]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/highlight-boxes/nerd-tip-box'
      )
    ),
  [NOOP]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/no-op')
    ),
  // (0 , l.default)(...) is not a function
  [OUTOFDATEMESSAGE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/out-of-date-message'
      )
    ),
  [ONETRUSTOPENCONSENT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/onetrust-open-consent'
      )
    ),
  [OUTSIDEEXPERT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/highlight-boxes/outside-expert'
      )
    ),
  [PERSONALLOANCALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculators/personal-loan'
      )
    ),
  [PERSONALLOANSBESTOFAWARDWINNERCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/personal-loans-best-of-award-winner-card'
      )
    ),
  [PERSONALLOANSTINYWIDGET]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/personal-loans-tiny-widget'
      )
    ),
  [PERSONALLOANSWIDGETIZEDTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/personal-loans-widgetized-table'
      )
    ),
  [PETINSURANCEBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/pet-insurance-banner'
      )
    ),
  [POSTLIST]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/post-list')
    ),
  [PREQUALAPPLICATIONHOUSEAD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/prequal-application-house-ad'
      )
    ),
  [PREQUALBANNER]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/prequal-banner')
    ),
  [PRODUCTSTARRATING]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/product-star-rating'
      )
    ),
  [PROPERTYTAXTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/property-tax-table'
      )
    ),
  [QUESTIONLIST]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/question-list')
    ),
  [REDIRECT]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/redirect')
    ),
  [REFERRALBANNER]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/referral-banner')
    ),
  [REFINANCECALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculators/refinance'
      ).then((module) => module[REFINANCECALCULATOR])
    ),
  [RENDERCONTEXTCONDITIONAL]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/render-context-conditional/render-context-conditional'
      )
    ),
  [RENTERSINSURANCEBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/renters-insurance-banner'
      )
    ),
  [RENTERSINSURANCEENTRYPOINT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/renters-insurance-entry-point'
      )
    ),
  [RENTVSBUYCALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculators/rent-vs-buy'
      )
    ),
  [RETIREMENTCALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculators/retirement'
      )
    ),
  [REVIEWDETAILSOFFER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/review-details-offer'
      )
    ),
  [REVIEWINTROOFFER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/review-intro-offer'
      )
    ),
  [REVIEWJSONLD]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/review-json-ld')
    ),
  [ROTHIRACALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculators/roth-ira'
      )
    ),
  [CREDITCARDSUPDATEDDATESECTION]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-updated-date-section'
      )
    ),
  [ROUNDUPJSONLD]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/roundup-json-ld')
    ),
  [ROUNDUPOFFERSCD]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/roundup-offers/cd')
    ),
  [ROUNDUPOFFERSHYSA]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/roundup-offers/hysa'
      )
    ),
  [SCREENSIZECONDITIONAL]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/screen-size-conditional/screen-size-conditional'
      )
    ),
  [SCROLLDEPTHCONDITIONAL]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/scroll-depth-conditional'
      )
    ),
  [SIMILARCARS]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/similar-cars')
    ),
  [SHOWMORETOGGLE]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/show-more-toggle')
    ),
  [SMBMULTIDRIVERPRODUCTCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/smb-multi-driver-product-card'
      )
    ),
  [SMBCOMPARELOANSENTRYPOINT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/smb-compare-loans-entry-point'
      )
    ),
  [SMBCUSTOMADCTA]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/smb-custom-ad-cta')
    ),
  [SMBSINGLEDRIVERPRODUCTCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/smb-single-driver-product-card'
      )
    ),
  [SMBSUMMARYTABLE]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/smb-summary-table')
    ),
  [SOCIALMEDIALINKS]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/social-media-links'
      )
    ),
  [SOCIALMEDIASHARELINKS]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/social-media-share-links'
      )
    ),
  [SOCIALSECURITYCALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/social-security-calculator'
      )
    ),
  [SPACER]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/spacer')
    ),
  [SPOTIFY]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/spotify')
    ),
  [STARRATING]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/star-rating')
    ),
  [STICKYCONTAINER]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/sticky-container')
    ),
  [STUDENTLOANORIGINATIONBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/student-loan-origination-banner'
      )
    ),
  [STUDENTLOANSBESTOFAWARDWINNERCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/student-loans-best-of-award-winner-card'
      )
    ),
  [INSURANCESUMMARYTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/insurance-summary-table'
      )
    ),
  [TAB]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/tabs').then(
        (module) => module[TAB]
      )
    ),
  [TABLE]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/table')
    ),
  [TABLEOFCONTENTS]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/table-of-contents')
    ),
  [TABLEOFCONTENTSTARGET]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/table-of-contents/table-of-contents-target'
      )
    ),
  [TABS]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/tabs').then(
        (module) => module[TABS]
      )
    ),
  [TAXCALCULATOR]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/calculators/tax')
    ),
  [TAXMONETIZINGADBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/tax-monetizing-ad-banner'
      )
    ),
  [TIKTOK]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/tiktok')
    ),
  [TITLE]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/title')
    ),
  [TWITTER]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/twitter')
    ),
  [TOOLLIST]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/tool-list').then(
        (module) => module[TOOLLIST]
      )
    ),
  [TOOLLISTITEM]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/tool-list').then(
        (module) => module[TOOLLISTITEM]
      )
    ),
  [TRAVELINSURANCEBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/travel-insurance-banner'
      )
    ),
  [TRUECARAD]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/true-car-ad')
    ),
  [TYPE]: () =>
    dynamic(() =>
      import('@nerdwallet/currency/components/NativeType').then(
        (module) => module.NativeType
      )
    ),
  [USERENGAGEMENTCTA]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/user-engagement-cta'
      )
    ),
  [VEHICLEOVERVIEWCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/vehicle-overview-card'
      )
    ),
  [VIDEO]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/video')
    ),
  [USERSEGMENTCONDITIONAL]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/user-segment-conditional'
      )
    ),
  [WELL]: () =>
    dynamic(() =>
      import('@nerdwallet/currency/components/Well').then(
        (module) => module.Well
      )
    ),
  [WPAUTHORSBOX]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/wp-authors-box')
    ),
  [WPBIOHEADER]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/wp-bio-header')
    ),
  [WPBLOCK]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/wp-block')
    ),
  [WPCALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculator/wp-calculator'
      )
    ),
  [WPCONTENTPAGEHEADER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/wp-content-page-header'
      )
    ),
  [WPCONTENTPAGENERDAICHAT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/wp-content-page-nerd-ai-chat'
      )
    ),
  [WPDYNAMICPLACEMENT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/wp-dynamic-placement'
      )
    ),
  [WPEDITLINK]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/wp-edit-link')
    ),
  [WPEMBED]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/wp-embed')
    ),
  [WPFEATUREDIMAGE]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/wp-featured-image')
    ),
  [WPHOUSEAD]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/chunks/article').then(
        (module) => module[WPHOUSEAD]
      )
    ),
  [WPHUBHEADER]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/wp-hub-header')
    ),
  [WPHUBLINKS]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/wp-hub-links')
    ),
  [WPINLINEBLOCK]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/wp-inline-block')
    ),
  [WPMARKETPLACEENTRYPOINT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/wp-marketplace-entry-point'
      )
    ),
  [WPMETHODOLOGY]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/wp-methodology')
    ),
  [WPINSPAGEPOSTLIST]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/wp-post-list'
      ).then((module) => module[WPINSPAGEPOSTLIST])
    ),
  [WPPOSTLIST]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/wp-post-list'
      ).then((module) => module[WPPOSTLIST])
    ),
  [WPREVIEWPOSTLIST]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/wp-post-list'
      ).then((module) => module[WPREVIEWPOSTLIST])
    ),
  [WPSOCIALMEDIALINKS]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/wp-social-media-links'
      )
    ),
  [WPTABLE]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/wp-table/wp-table')
    ),
  [TEMPLATESECTION]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/template-section')
    ),
  [SMBNEWPRODUCTCARDTILE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/smb-new-product-card-tile'
      ).then((module) => module[SMBNEWPRODUCTCARDTILE])
    ),
  [SMBPRODUCTCARDTILE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/smb-product-card-tile'
      )
    ),
  [SMBINFOGATHERINGCTA]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/smb-info-gathering-cta'
      )
    ),
  [SMBPROSANDCONSTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/smb-pros-and-cons-table'
      )
    ),
  [ICONCARDLIST]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/icon-card-list')
    ),
  [SUPERSCRIPT]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/superscript')
    ),
  [CONTENTENGAGEMENTSECTION]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/content-engagement-section'
      )
    ),
  [INLINECODE]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/inline-code')
    ),
  [CODEBLOCK]: () =>
    dynamic(() =>
      import('@nerdwallet/typography').then((module) => module[CODEBLOCK])
    ),
  [CREDITCARDSCOMPACTDRIVERPRODUCTCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-compact-driver-product-card'
      )
    ),
  [CREDITCARDSRELATEDPRODUCTSCONTAINER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-related-products-container'
      )
    ),
  [NERDWALLETADVISORSANNOUNCEMENTBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/nerdwallet-advisors-announcement-banner'
      )
    ),
  [NERDWALLETADVISORSBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/nerdwallet-advisors-banner'
      )
    ),
  [NERDWALLETADVISORSMATCHDYNAMICBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/nerdwallet-advisors-match-dynamic-banner'
      )
    ),
  [NERDWALLETADVISORSMATCHSTATICBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/nerdwallet-advisors-match-static-banner'
      )
    ),
  [NERDWALLETADVISORSSIDESTICKYBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/nerdwallet-advisors-side-sticky-banner'
      )
    ),
  [NERDWALLETPLUSINSURANCEBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/nerdwallet-plus-insurance-banner'
      )
    ),
  [AUTOINSURANCECALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-calculator'
      )
    ),
  [CREDITCARDSOFFERRATESANDFEESLINK]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/credit-cards-offer-rates-and-fees-link'
      )
    ),
  [HOMEAFFORDABILITYCALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/calculators/home-affordability'
      ).then((module) => module[HOMEAFFORDABILITYCALCULATOR])
    ),
  [HOMEINSURANCECALCULATOR]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/home-insurance-calculator'
      )
    ),
  [LENDINGBESTOFAWARDWINNERCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/lending-best-of-award-winner-card'
      )
    ),
  [LENDINGSUMMARYPRODUCTCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/lending-summary-product-card'
      )
    ),
  // [BAINARTICLEHERO]: () => [
  //   import('@nerdwallet/structured-content/dist/components/bain-article-hero'),
  // ),
  // [BAINLANDINGHERO]: () => [
  //   import('@nerdwallet/structured-content/dist/components/bain-landing-hero'),
  // ),
  // [BAINSOFILTOTOPBANNER]: () => [
  //   import('@nerdwallet/structured-content/dist/components/bain-sofi-lto-top-banner'),
  // ),
  // [BAINTAXANNOUNCEMENTBANNER]: () => [
  //   import('@nerdwallet/structured-content/dist/components/bain-tax-announcement-banner'),
  // ),
  // [BAINTAXDISCLOSURETEXT]: () => [
  //   import('@nerdwallet/structured-content/dist/components/bain-tax-disclosure-text'),
  // ),
  // [BAINTAXINSIGHTS]: () => [
  //   import('@nerdwallet/structured-content/dist/components/bain-tax-insights'),
  // ),
  // [BAINTAXPOPUP]: () => [
  //   import('@nerdwallet/structured-content/dist/components/bain-tax-pop-up'),
  // ),
  // [BAINTAXPRICINGCHART]: () => [
  //   import('@nerdwallet/structured-content/dist/components/bain-tax-pricing-chart'),
  // ),
  // [BAINTAXSTICKYBANNER]: () => [
  //   import('@nerdwallet/structured-content/dist/components/bain-tax-sticky-banner'),
  // ),
  // [COLORSTRIPE]: () => [
  //   import('@nerdwallet/structured-content/dist/components/color-stripe'),
  // ),
  [HOMEINSURANCECLICKTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/home-insurance-click-table'
      )
    ),
  [INSURANCEAIRTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/insurance-air-table'
      )
    ),
  [LENDINGCUSTOMIZABLEMARKETPLACERATETABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/lending-customizable-marketplace-rate-table'
      )
    ),
  [PETINSURANCEINFOCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/pet-insurance-info-card'
      )
    ),
  [PROMOCARD]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/promo-card')
    ),
  [SEARCHPAGEHEADER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/search-page-header'
      )
    ),
  [SEARCHRESULTLISTDATA]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/search-result-list-data'
      )
    ),
  [SMBBUSINESSPROREGISTRATION]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/smb-business-pro-registration'
      )
    ),
  [SMBPARTNERPLACEMENT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/smb-partner-placement'
      )
    ),
  [SMBILLUSTRATIONCARDLIST]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/smb-illustration-card-list'
      )
    ),
  [AUTOINSURANCECLICKTABLE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/auto-insurance-click-table'
      )
    ),
  [GATEDCONTENTBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/gated-content-banner'
      )
    ),
  [SMBWHYTRUSTNERDWALLET]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/smb-why-trust-nerd-wallet'
      ).then((module) => module[SMBWHYTRUSTNERDWALLET])
    ),
  [SMBWHYTRUSTNERDWALLETBULLET]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/smb-why-trust-nerd-wallet'
      ).then((module) => module[SMBWHYTRUSTNERDWALLETBULLET])
    ),
  [NERDUPPROMOTIONALBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/nerdup-promotional-banner'
      )
    ),
  [TRAVELINSURANCEENTRYPOINT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/travel-insurance-entry-point'
      )
    ),
  [TREASURYYIELDVALUE]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/treasury-yield-value'
      )
    ),
  [NERDWALLETPLUSCTA]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/nerdwallet-plus-cta'
      )
    ),
  [NERDWALLETPLUSBANNER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/nerdwallet-plus-banner'
      )
    ),
  [AURABANNER]: () =>
    dynamic(() =>
      import('@nerdwallet/structured-content/dist/components/aura-banner')
    ),
  [TURBOTAXPLACEMENT]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/turbo-tax-placement'
      )
    ),
  [ARTICLEPAGEHEADER]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/article-page-header'
      )
    ),
  [CONTEXTUALFLEXCARD]: () =>
    dynamic(() =>
      import(
        '@nerdwallet/structured-content/dist/components/contextual-flex-card'
      )
    ),
};
